export const API_CONSTANTS = {
  ACCESS_TOKEN: 'access_token',
  CHECK_TOKEN_INTERVAL: 300000,
};
